import { render } from "./RoutePath.vue?vue&type=template&id=34e9812c"
import script from "./RoutePath.vue?vue&type=script&lang=js"
export * from "./RoutePath.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__